module.exports = __webpack_public_path__ + "img/02n@2x.650295f2.svg";